(function () {
    'use strict';

    angular
        .module('Lavpop-store', [
            'ngSanitize',
            'ui.router',
            'ui.select',
            'smart-table',
            '19degrees.ngSweetAlert2',
            'angularValidator',
            'ngMask',
            'ngNotify',
            'ui.bootstrap.materialPicker',
            'daterangepicker',
            'Firestitch.angular-counter',

            'Lavpop-store.configs',
            'Lavpop-store.constants',
            'Lavpop-store.components',
            'Lavpop-store.directives',
            'Lavpop-store.filters',
            'Lavpop-store.interceptors',
            'Lavpop-store.routes',
            'Lavpop-store.services',
        ])
        .run(run);

    /** @ngInject */
    function run($trace, $transitions, $rootScope, $window, HelperService) {
        $trace.enable(1, 5);

        HelperService.handleOnRun();

        $rootScope.$on('$locationChangeStart', event => {
            HelperService.handleLocationChangeStart(event);
        });

        $transitions.onEnter({}, $transition => {
            return HelperService.handleStateChangeStart($transition);
        });

        $transitions.onSuccess({}, $transition => {
            $rootScope.pageTitle = `${$transition.to().title} - Central de Compras LavPop`;

            HelperService.handleStateChangeSuccess();
        });

        $transitions.onError({}, ($transition, error) => {
            console.log('$transition: ', $transition);
            console.log('error: ', error);
            HelperService.handleStateChangeError(error);
        });

        $window.onload = () => {
            HelperService.handleViewContentLoaded();
        }

        angular.element($window).on('resize', () => $rootScope.isMobile = HelperService.isScreenSmaller(991));

        $rootScope.$on('$viewContentLoaded', HelperService.handleViewContentLoaded);
    }
})();